module.exports = __webpack_public_path__ + "img/XRP-icon.347a2875.svg";